export const envConfig = {
    formalServer: process.env.NODE_ENV === 'production' ? 'https://server.cottongame.com' :
        process.env.NODE_ENV === 'dev' ? 'http://192.168.0.119:9098' : 'https://dev.cottongame.com'
}
